import { render, staticRenderFns } from "./google-captcha.vue?vue&type=template&id=325db1ff&"
import script from "./google-captcha.vue?vue&type=script&lang=js&"
export * from "./google-captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports